/* eslint-disable */
import { useQuery } from '@tanstack/react-query';
import { api } from 'constants/api';
import { AudienceType } from 'types/create-campaign';
import { ApiResponse } from 'types/utils/api-response';
import { QueryOptions } from 'types/utils/query-options';

export type AudienceListResponseType = AudienceType[];

export const useGetAudienceList = (
  options: QueryOptions<AudienceListResponseType> = {}
) => {
  const { refetch, ...rest } = useQuery({
    queryFn: async (): Promise<AudienceListResponseType> => {
      const { data } =
        await api.get<ApiResponse<AudienceListResponseType>>(`/audience/list`);

      return data.data;
    },
    queryKey: ['audience'],
    ...options,
  });

  return { refetch, ...rest };
};
